<template>
    <div class="dropdown-divider"></div>
</template>

<script>
export default {
  name: 'DropdownDivider',

  props: {
    dark: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
  .dropdown-divider {
    border-top-width: 1px;
    border-top-style: solid;
    border-top-color: rgba(255, 251, 243, 0.4);

    transition: border-top-color 350ms ease;
  }

  .solid {
    .dropdown-divider {
      border-top-color: rgba(0, 0, 0, 0.35);
    }
  }
</style>
